import React, { createElement } from 'react';
// import { getAlgoliaResults } from '@algolia/autocomplete-js';
import env from "react-dotenv";
import algoliasearch from 'algoliasearch/lite';
import { Configure, InstantSearch } from 'react-instantsearch-hooks';

import { Autocomplete } from './Autocomplete';
import Hits from './Hits';
import Hit from './Hit';

const appId = env.ALGOLIA_APP_ID;
const apiKey = env.ALGOLIA_API_KEY;
const searchClient = algoliasearch(appId, apiKey);
const INSTANT_SEARCH_INDEX_NAME = env.ALGOLIA_DEALS_INDEX;

const MarketPlaceSearch = () => {
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={INSTANT_SEARCH_INDEX_NAME}
      // routing
      searchFunction={(helper) => {
        const container = document.querySelector('#marketPlaceResults');
        if (container) {
          container.style.display = helper.state.query === '' ? 'none' : '';
        }

        helper.search();
      }}
    >
      <Autocomplete
        searchClient={searchClient}
        placeholder="Search deals"
        detachedMediaQuery="none"
        openOnFocus
      />
      <Configure
        attributesToSnippet={['name:7', 'description:15']}
        snippetEllipsisText="…"
        hitsPerPage={5}
      />
      <Hits hitComponent={Hit} />
    </InstantSearch>
  );
};

export default MarketPlaceSearch;